export const MODULE = "sales-order-invoicing-create";
